var AppLoadingService = /** @class */ (function () {
    function AppLoadingService(_a) {
        var flowAPI = _a.flowAPI, panoramaClient = _a.panoramaClient;
        var _this = this;
        this.isCSRLoadStartReported = false;
        this.isCSRLoadFinishReported = false;
        this.onAppLoaded = function () {
            var _a, _b;
            if (!_this.isCSRLoadFinishReported) {
                (_a = _this.flowAPI.fedops) === null || _a === void 0 ? void 0 : _a.appLoaded();
                (_b = _this.panoramaClient) === null || _b === void 0 ? void 0 : _b.reportLoadFinish();
                _this.isCSRLoadFinishReported = true;
            }
        };
        this.onAppLoadStarted = function () {
            var _a;
            if (!_this.isCSRLoadStartReported) {
                (_a = _this.panoramaClient) === null || _a === void 0 ? void 0 : _a.reportLoadStart();
                _this.isCSRLoadStartReported = true;
            }
            if (!_this.isCSRLoadFinishReported) {
                _this.flowAPI.appLoadStarted();
            }
        };
        this.flowAPI = flowAPI;
        this.panoramaClient = panoramaClient;
    }
    return AppLoadingService;
}());
export { AppLoadingService };
//# sourceMappingURL=appLoadingService.js.map